import { uniqBy } from "lodash";
import { handleActions } from "redux-actions";

import { updateById } from "utils";
import { fullName } from "utils/user";

const withFullName = (contact) => ({
  ...contact,
  name: fullName(contact),
});

const contactReducer = handleActions(
  {
    ASSET_CONTACTS_GET: {
      FULFILLED: ({ assetContacts }, { payload: { contacts } }) => ({
        assetContacts: uniqBy([...assetContacts, ...contacts.map(withFullName)], "id"),
      }),
    },

    ASSET_CONTACT_UPDATE: {
      FULFILLED: ({ assetContacts }, { payload: { contact } }) => ({
        assetContacts: updateById(assetContacts, withFullName(contact)),
      }),
    },

    ASSET_CONTACT_CREATE: {
      FULFILLED: ({ assetContacts }, { payload: { contact } }) => ({
        assetContacts: [...assetContacts, withFullName(contact)],
      }),
    },

    ASSET_CONTACT_DELETE: {
      FULFILLED: ({ assetContacts }, { meta: { contactID } }) => ({
        assetContacts: assetContacts.filter((contact) => contact.id !== contactID),
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default contactReducer;
